import type { SettingGridRow } from "../settingsTree";

import { FLAG_TOOLTIPS } from "../settingFlags";
import style from "./style.module.scss";

interface Props {
	row: SettingGridRow;
}

/** Secret, Required and Cached badges for the flags the setting's definition sets. None for a flag that's off or not sure */
export function SettingFlagBadges({ row }: Props) {
	if (row.isSecret !== true && !row.isRequired && !row.cached) return null;
	return (
		<div className={style.pills}>
			{row.isSecret === true && (
				<span className={style.secretBadge} title={FLAG_TOOLTIPS.secret}>
					Secret
				</span>
			)}
			{row.isRequired && (
				<span className={style.requiredBadge} title={FLAG_TOOLTIPS.required}>
					Required
				</span>
			)}
			{row.cached && (
				<span className={style.cachedBadge} title={FLAG_TOOLTIPS.cached}>
					Cached
				</span>
			)}
		</div>
	);
}
